import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { APIResultData, PaginationOptions } from '@yourcause/common';
import { CommunicationForApplicant } from '../typings/applicant-communications.typing';

@Injectable({ providedIn: 'root' })
export class ApplicantCommunicationResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  async getApplicationCommunications (
    applicationId: number
  ): Promise<APIResultData<CommunicationForApplicant>> {
    const paginationOptions: PaginationOptions<CommunicationForApplicant> = {
      rowsPerPage: 1000,
      pageNumber: 1,
      sortColumns: [{
        columnName: 'sentDate',
        sortAscending: false
      }],
      filterColumns: [],
      orFilterColumns: [],
      retrieveTotalRecordCount: true,
      returnAll: true
    };
    const endpoint = 'api/portal/applications/emails';

    return this.httpRestService.post(endpoint, {
      paginationOptions,
      applicationId
    });
  }

  getApplicationCommunicationDetail (
    emailQueueId: number,
    applicationId: number
  ) {
    const endpoint = `api/portal/applications/GetEmailDetails/${emailQueueId}/${applicationId}`;

    return this.httpRestService.get(endpoint);

  }

}
